import { render } from "./TrainingWeekStats.vue?vue&type=template&id=7359dffd&scoped=true"
import script from "./TrainingWeekStats.vue?vue&type=script&lang=js"
export * from "./TrainingWeekStats.vue?vue&type=script&lang=js"

import "./TrainingWeekStats.vue?vue&type=style&index=0&id=7359dffd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7359dffd"]])

export default __exports__